export const COMMENTS_REQUEST_DEFAULT_PAGE_SIZE = 10;
